var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 40" } },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#F2F2F7",
          "fill-rule": "evenodd",
          d:
            "M10.256 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 39.48 3.9c.666 1.244 1.019 2.473 1.019 5.87v20.483c0 3.397-.353 4.63-1.02 5.874a6.946 6.946 0 0 1-2.86 2.858C35.382 39.648 34.148 40 30.75 40H10.256c-3.398 0-4.633-.353-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858C.853 34.884.5 33.65.5 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.91 6.91 0 0 1 4.38 1.02C5.633.357 6.858 0 10.256 0z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#253B80",
          d:
            "m14.007 31.614.462-2.79-1.03-.023H8.524L11.94 8.216a.262.262 0 0 1 .095-.162.288.288 0 0 1 .182-.064h8.29c2.753 0 4.652.545 5.644 1.619.465.504.761 1.03.904 1.61.15.608.153 1.334.006 2.22l-.01.065v.567l.465.25c.355.172.674.403.941.683.398.43.655.978.764 1.627.112.668.075 1.462-.11 2.362-.211 1.034-.554 1.935-1.017 2.673a5.612 5.612 0 0 1-1.613 1.68c-.615.414-1.346.73-2.173.93-.8.199-1.714.299-2.715.299h-.645c-.461 0-.91.158-1.261.44a1.835 1.835 0 0 0-.658 1.116l-.049.251-.816 4.917-.037.18c-.01.058-.027.086-.052.106a.141.141 0 0 1-.084.03h-3.984z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#179BD7",
          d:
            "M27.955 13.569c-.025.15-.053.304-.085.462-1.093 5.333-4.834 7.176-9.61 7.176h-2.433c-.584 0-1.077.403-1.168.95l-1.245 7.505-.353 2.128a.562.562 0 0 0 .142.476.649.649 0 0 0 .473.207h4.314c.51 0 .945-.353 1.025-.831l.042-.209.813-4.897.052-.27c.08-.48.514-.832 1.025-.832h.645c4.18 0 7.452-1.613 8.408-6.279.4-1.949.193-3.576-.864-4.721a4.106 4.106 0 0 0-1.181-.865z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#222D65",
          d:
            "M26.812 13.136a9.03 9.03 0 0 0-1.063-.224 14.21 14.21 0 0 0-2.144-.149h-6.499a1.07 1.07 0 0 0-.674.237.973.973 0 0 0-.35.596l-1.382 8.32-.04.242c.043-.265.184-.506.399-.68.214-.175.487-.27.769-.27h2.432c4.777 0 8.517-1.844 9.61-7.177.033-.158.06-.311.086-.462a5.992 5.992 0 0 0-.9-.36 8.29 8.29 0 0 0-.244-.073z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#253B80",
          d:
            "M16.082 13.596c.038-.232.162-.444.35-.597s.427-.236.674-.235h6.498c.77 0 1.489.048 2.145.148.443.067.881.166 1.309.297.322.101.622.222.898.36.326-1.97-.002-3.313-1.124-4.528-1.236-1.338-3.468-1.91-6.324-1.91h-8.29c-.583 0-1.081.402-1.171.95L7.594 28.88a.644.644 0 0 0 .161.545.742.742 0 0 0 .541.238h5.119l1.285-7.748 1.382-8.319z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }